export default __webpack_public_path__ + "static/media/doneDropoff.6db1b490.svg";